import { $, addEvent, removeEvent } from './common/dom';
import { curlGateWay } from './common/ajax';
import { language, getQueryVariable } from './common/utils';

const imgUrl = 'https://img.tinhnow.com/wownow/static/img/countdown.png'

const handleDOMEvents = function (eventOperation, el, eventObj) {
  eventOperation(el, "touchstart", eventObj);
  eventOperation(document, "touchmove", eventObj);
  eventOperation(document, "touchcancel", eventObj);
  eventOperation(document, "touchend", eventObj);

  eventOperation(el, "mousedown", eventObj);
  eventOperation(document, "mousemove", eventObj);
  eventOperation(document, "mouseup", eventObj);
  eventOperation(document, "mousecancel", eventObj);
};

const getPageRect = function (event) {
  let pageX = event.pageX
  let pageY = event.pageY
  if (event.touches) {
    pageX = event.touches[0].pageX
    pageY = event.touches[0].pageY
  }
  return { pageX, pageY }
}

// 获取当前浏览任务
const getBrowseTask = (params, config) => curlGateWay(params, `app/channel/task/getBrowseTask`, config);

// 上送浏览数据
const deliveryBrowse = (params, config) => curlGateWay(params, `app/channel/task/deliveryBrowse`, config);

class Countdown {
  constructor(options = {}) {
    if (!options.browseType) {
      console.log('browseType参数为空。不需要调接口获取倒计时详情')
      return false
    }
    const getBrowseTaskOptions = {
      browseType: options.browseType
    }
    if (options.taskId) getBrowseTaskOptions.taskNo = options.taskId
    if (options.taskNo) getBrowseTaskOptions.taskNo = options.taskNo
    if (!getBrowseTaskOptions.taskNo && location.href.indexOf('taskNo') > -1) {
      getBrowseTaskOptions.taskNo = getQueryVariable('taskNo')
    }
    getBrowseTask(getBrowseTaskOptions).then(res => {
      console.log('getBrowseTask', res)
      if (!res.data.hasBrowseTask) return true
      this.deliveryBrowseOptions = res.data
      this.isTouch = false
      this.touchInfo = {}
      this.encode = res.data.encode
      this.showTime = res.data.browseTime
      this.taskNo = res.data.taskNo
      this.postOptions = options.postOptions || {}
      this.handleEvent = {
        name: "canvasEvents",
        handleEvent: (event) => {
          switch (event.type) {
            case "mousedown":
            case "touchstart":
              this.touchstart(event)
              break;
            case "touchmove":
            case "mousemove":
              this.touchmove(event)
              break;
            case "touchend":
            case "mouseup":
            case "touchcancel":
            case "mousecancel":
              this.touchend(event)
              break;
          }
        },
      }
      this.el = this.createCountdown()
      this.loop()
    })
  }
  touchstart(event) {
    this.isTouch = true
    this.isMove = false
    this.touchInfo = getPageRect(event)
  }
  touchmove(event) {
    if (this.isTouch) {
      event.preventDefault()
      this.isMove = true
      let _touchInfo = getPageRect(event)
      const rect = this.el.getBoundingClientRect()
      this.setCountdownRect(
        this.el,
        rect.left + _touchInfo.pageX - this.touchInfo.pageX,
        rect.top + _touchInfo.pageY - this.touchInfo.pageY,
      )
      this.el.style.right = `inherit`
      this.touchInfo = _touchInfo
    }
  }
  touchend(event) {
    if (this.isTouch && this.isComplete && !this.isMove) {
      // 调接口
      // handleDOMEvents(removeEvent, this.el, this.handleEvent)
      // document.body.removeChild(this.el)
      if (this.encode) {
        window.location.href = this.encode
        return false
      }
      if (location.origin.indexOf('sit') > -1
        || location.origin.indexOf('localhost') > -1 ||
        location.origin.indexOf('127.0.0.1') > -1
      ) {
        window.location.href = 'https://h5-sit.lifekh.com/mobile-h5/vip/task-center'
      } else if (location.origin.indexOf('uat') > -1) {
        window.location.href = 'https://h5-uat.lifekh.com/mobile-h5/vip/task-center'
      } else  {
        window.location.href = 'https://h5.lifekh.com/mobile-h5/vip/task-center'
      }
    }
    this.isTouch = false
  }
  createCountdown() {
    let text = 'Completed'
    if (language == 'zh') text = '\u4efb\u52a1\u5b8c\u6210'
    if (language == 'km') text = 'កិច្ចការបានបញ្ចប់'
    let el = $(`
      <div class="wownow-h5-countdown">
        <img class="wownow-h5-countdownIcon" src="${imgUrl}" draggable="false" />
        <div class="wownow-h5-countdownText">${text}</div>
        <div class="wownow-h5-countdownMiddle">
          <span class="wownow-h5-countdownCount">${this.showTime}</span>
          <span class="wownow-h5-countdownUnit">S</span>
        </div>
      </div>
    `)
    const style = document.createElement('style')
    style.textContent = `
      .wownow-h5-countdown{
        position: fixed;
        top: 5px;
        right: 14px;
        z-index: 30000;
        cursor: pointer;
      }
      .wownow-h5-countdownIcon{
        display: block;
        margin: 0 auto;
        width: 52px;
        height: 58px;
      }
      .wownow-h5-countdownText{
        margin-top: -12px;
        display: inline-block;
        vertical-align: top;
        padding: 5px 9px;
        height: 20px;
        line-height: 1;
        font-size: 10px;
        font-weight: 500;
        color: #EE6006;
        white-space: nowrap;
        box-sizing: border-box;
        border-radius: 10px;
        background: #FDF4D9;
        border-radius: 10px;
        border: 1px solid #F8D450;
        box-shadow: 0 2px 0 0 #EF9036;
        opacity: 0;
        transition: opacity .3s;
        -webkit-transition: opacity .3s;
      }
      .wownow-h5-countdownMiddle{
        position: absolute;
        top: 22px;
        left: 50%;
        color: #EE6006;
        font-size: 0;
        line-height: 21px;
        transform: translateX(-50%);
        -webkit-transform: translateX(-50%);
        white-space: nowrap;
        text-align: center;
        padding-right: 6px;
        z-index: 10;
      }
      .wownow-h5-countdownCount{
        font-size: 15px;
        font-weight: 500;
      }
      .wownow-h5-countdownUnit{
        font-size: 13px;
        font-weight: 500;
      }
    `
    handleDOMEvents(addEvent, el, this.handleEvent)
    document.body.appendChild(el)
    document.head.appendChild(style)
    return el
  }
  loop() {
    this.looper = setTimeout(() => {
      let countdownCount = document.querySelector('.wownow-h5-countdownCount')
      countdownCount.innerHTML = this.showTime
      if (this.showTime <= 0) {
        this.showText()
      } else {
        this.loop()
      }
      this.showTime -= 1
    }, 1000)
  }
  showText() {
    let text = document.querySelector('.wownow-h5-countdownText')
    text.style.opacity = 1
    this.isComplete = true
    deliveryBrowse({
      browseType: this.deliveryBrowseOptions.browseType,
      specifyUrl: this.deliveryBrowseOptions.specifyUrl,
      browseTime: this.deliveryBrowseOptions.browseTime,
      ...this.postOptions
    })
  }
  setCountdownRect(el, x, y) {
    const rect = el.getBoundingClientRect()
    const minX = 0
    const maxX = document.body.clientWidth - rect.width
    const minY = 0
    const maxY = document.body.clientHeight - rect.height
    el.style.left = `${Math.min(maxX, Math.max(x, minX))}px`
    el.style.top = `${Math.min(maxY, Math.max(y, minY))}px`
  }
  destroy() {
    if (this.el) {
      handleDOMEvents(removeEvent, this.el, this.handleEvent)
      document.body.removeChild(this.el)
    }
  }
}

export default function (options) {
  if (window.countdownInstance) {
    clearTimeout(window.countdownInstance.looper)
    window.countdownInstance.destroy()
  }
  window.countdownInstance = new Countdown(options)
  return window.countdownInstance
}
